import { render } from "./Loan_Recovery.vue?vue&type=template&id=2a8aef77"
import script from "./Loan_Recovery.vue?vue&type=script&lang=js"
export * from "./Loan_Recovery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__